var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShildIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4248 3.85921L4.45178 5.53092C4.32151 5.59605 4.23467 5.7046 4.25638 5.81316C4.25638 7.81053 5.08138 11.2408 8.29454 12.7605C8.38138 12.8039 8.46823 12.8039 8.53336 12.7605C11.7465 11.2191 12.5715 7.81053 12.5932 5.81316C12.5932 5.7046 12.5064 5.59605 12.3978 5.53092L8.4248 3.85921ZM8.70704 2.83882L12.7886 4.57566C13.2663 4.79276 13.6353 5.24868 13.6353 5.81316C13.6136 7.98421 12.7235 11.9138 8.98928 13.7158C8.6202 13.8895 8.2077 13.8895 7.83862 13.7158C4.10441 11.9138 3.21428 7.98421 3.21428 5.81316C3.19257 5.24868 3.56165 4.79276 4.03928 4.57566L8.12086 2.83882C8.2077 2.79539 8.31625 2.77368 8.4248 2.77368C8.51165 2.77368 8.6202 2.79539 8.70704 2.83882Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShildIcon);
export default __webpack_public_path__ + "static/media/ShildIcon.ae633d9a3b433cad470a1c89463f14cd.svg";
export { ForwardRef as ReactComponent };